/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BudgetSummaryResponse
 */
export interface BudgetSummaryResponse {
    /**
     * 
     * @type {number}
     * @memberof BudgetSummaryResponse
     */
    totalBudgetFromPOAMs?: number;
    /**
     * 
     * @type {number}
     * @memberof BudgetSummaryResponse
     */
    totalAllocatedFromPOAMItems?: number;
}

/**
 * Check if a given object implements the BudgetSummaryResponse interface.
 */
export function instanceOfBudgetSummaryResponse(value: object): value is BudgetSummaryResponse {
    return true;
}

export function BudgetSummaryResponseFromJSON(json: any): BudgetSummaryResponse {
    return BudgetSummaryResponseFromJSONTyped(json, false);
}

export function BudgetSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BudgetSummaryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalBudgetFromPOAMs': json['totalBudgetFromPOAMs'] == null ? undefined : json['totalBudgetFromPOAMs'],
        'totalAllocatedFromPOAMItems': json['totalAllocatedFromPOAMItems'] == null ? undefined : json['totalAllocatedFromPOAMItems'],
    };
}

export function BudgetSummaryResponseToJSON(json: any): BudgetSummaryResponse {
    return BudgetSummaryResponseToJSONTyped(json, false);
}

export function BudgetSummaryResponseToJSONTyped(value?: BudgetSummaryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalBudgetFromPOAMs': value['totalBudgetFromPOAMs'],
        'totalAllocatedFromPOAMItems': value['totalAllocatedFromPOAMItems'],
    };
}

